import React from "react"
import autobind from "class-autobind"
import { IWorkflowStep } from "../../models"
import { LinearProgress } from "material-ui"

interface IProps {
    step: IWorkflowStep
}

interface IState {
}

export default class WorkflowStepProgress extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        const percentDone = Math.round((this.props.step.CompletedTaskCount / this.props.step.TotalTaskCount) * 100)
        const title = `${this.props.step.CompletedTaskCount}/${this.props.step.TotalTaskCount} tasks completed ${percentDone}%`
        const inProgressColor = "#1181F2"
        const finishedColor = "#4CAF50"
        const progressColor = percentDone === 100 ? finishedColor : inProgressColor

        return (
            <div>
                {title}
                <LinearProgress mode="determinate" value={this.props.step.CompletedTaskCount} min={0} max={this.props.step.TotalTaskCount} color={progressColor} style={{height:8}}/>
            </div>
        )
    }
}